module.exports = __webpack_public_path__ + "img/Gheychi.f42af9fb.jpg";